export default __webpack_public_path__ + "static/media/lovingkindness_caption.cc66163e.jpeg";